import fecha from 'fecha';

const pt: fecha.i18nSettings = {
  dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
  dayNames: [
    'Domingo',
    'Segunda',
    'Terça',
    'Quarta',
    'Quinta',
    'Sexta',
    'Sábado',
  ],
  monthNamesShort: [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
  ],
  monthNames: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  amPm: ['am', 'pm'] as [string, string],
  DoFn: (day: number) => `${day}°`,
};

export const humanized = {
  SECONDS_AGO: 'Há um momento',
  A_MINUTE_AGO: 'Há um minuto',
  MINUTES_AGO: (mins: number) => `Há ${mins} minutos`,
  AN_HOUR_AGO: 'Há una hora',
  HOURS_AGO: (hours: number) => `Há ${hours} horas`,
  A_DAY_AGO: 'Há un dia',
  DAYS_AGO: (days: number) => `Há ${days} dias`,
  A_MONTH_AGO: 'Há un mês',
  MONTHS_AGO: (months: number) => `Há ${months} meses`,
  A_YEAR_AGO: 'Há un ano',
  YEARS_AGO: (years: number) => `Há ${years} anos`,
};

export const remaining = {
  SECONDS_AGO: 'um momento',
  A_MINUTE_AGO: 'um minuto',
  MINUTES_AGO: (mins: number) => `${mins} minutos`,
  AN_HOUR_AGO: 'una hora',
  HOURS_AGO: (hours: number) => `${hours} horas`,
  A_DAY_AGO: 'un dia',
  DAYS_AGO: (days: number) => `${days} dias`,
  A_MONTH_AGO: 'un mês',
  MONTHS_AGO: (months: number) => `${months} meses`,
  A_YEAR_AGO: 'un ano',
  YEARS_AGO: (years: number) => `${years} anos`,
};

export default pt;
